import { fontSizes } from "./../variables"
export const HeadingStyles = {
  baseStyle: {
    lineHeight: "heading",
  },
  variants: {
    regular: {
      fontFamily: "main",
      fontWeight: "normal",
    },

    bold: {
      fontFamily: "heading",
    },
  },

  sizes: {
    s: {
      fontSize: "s"
    },

    sm: {
      fontSize: "ms",
    },

    m: {
      fontSize: "m",
    },

    base: {
      fontSize: "xl",
    },

    lg: {
      fontSize: "xxl",
    },
  },
}
